import { render, staticRenderFns } from "./ProductHolder.vue?vue&type=template&id=ce40f506&scoped=true&"
import script from "./ProductHolder.vue?vue&type=script&lang=js&"
export * from "./ProductHolder.vue?vue&type=script&lang=js&"
import style0 from "./ProductHolder.vue?vue&type=style&index=0&id=ce40f506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce40f506",
  null
  
)

export default component.exports